/* unplugin-vue-components disabled */import { render } from "./tracker-contacts.vue?vue&type=template&id=47d6312f"
import script from "./tracker-contacts.vue?vue&type=script&lang=js"
export * from "./tracker-contacts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/tracker/tracker-contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47d6312f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47d6312f', __exports__)) {
    api.reload('47d6312f', __exports__)
  }
  
  module.hot.accept("./tracker-contacts.vue?vue&type=template&id=47d6312f", () => {
    api.rerender('47d6312f', render)
  })

}


export default __exports__